// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fy7m","input":"styles_input__2PxZZ"};